const auth = [
  {
    path: '/login',
    component: () => import('@/view/Layouts/AuthContainer/AuthContainer.vue'),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('@/view/pages/shared/auth/Login/Login.vue'),
        // A tela traz a própria arte e o próprio fundo, então o AuthContainer
        // não desenha o painel institucional aqui. Mesmo princípio do
        // `publicLayout` (86akftj33): a rota declara o que quer, em vez de ser
        // reconhecida de fora por nome ou caminho.
        meta: { ownLayout: true },
      },
      {
        path: '/reset_password',
        name: 'Recuperação de senha',
        component: () => import('@/view/pages/shared/auth/ResetPassword/ResetPassword.vue'),
      },
    ],
  },
  {
    path: '/login-mfa',
    name: 'LoginMFA',
    component: () => import('@/view/pages/shared/auth/LoginMfa.vue'),
  },
  // Rotas removidas na v3 do onboarding (feature/onboarding-v3, PR #1901) sem
  // redirect — links de indicação/e-mail já enviados antes da migração
  // caíam no catch-all de erro. Redirecionam pro equivalente atual do fluxo,
  // preservando a query string (ex.: ?indicator=).
  {
    path: '/register',
    redirect: to => ({ path: '/onboarding/start', query: to.query }),
  },
  {
    path: '/set-password',
    redirect: to => ({ path: '/onboarding/set-password', query: to.query }),
  },
  {
    path: '/mail-first-access',
    redirect: to => ({ path: '/onboarding/mail-first-access', query: to.query }),
  },
  {
    path: '/set-signature-password',
    redirect: to => ({ path: '/onboarding/set-signature-password', query: to.query }),
  },
  // A tela de seleção de conta foi removida a pedido do design (86ajvu56p): a
  // entrada passou a resolver a conta sozinha, sem parar para perguntar. Quem
  // tiver a URL guardada cai no login em vez do catch-all de erro.
  {
    path: '/linkselect',
    redirect: to => ({ path: '/login', query: to.query }),
  },
]

export default auth
